/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MovementOnFundsReportOperationFundDto
 */
export interface MovementOnFundsReportOperationFundDto {
  /**
   *
   * @type {string}
   * @memberof MovementOnFundsReportOperationFundDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MovementOnFundsReportOperationFundDto
   */
  name: string;
}

export function MovementOnFundsReportOperationFundDtoFromJSON(json: any): MovementOnFundsReportOperationFundDto {
  return MovementOnFundsReportOperationFundDtoFromJSONTyped(json, false);
}

export function MovementOnFundsReportOperationFundDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MovementOnFundsReportOperationFundDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function MovementOnFundsReportOperationFundDtoToJSON(value?: MovementOnFundsReportOperationFundDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
